import React from 'react';
export function Hero() {
  return <div className="mb-8" data-id="element-88">
      <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 leading-tight mb-6 font-sans" data-id="element-89">
        Doctors Call It the "72-Hour Danger Zone" When You Quit Drinking—
        <span className="bg-[#FEF3C7] px-1" data-id="element-90">Here's How I Got Through It</span>
      </h1>
    </div>;
}